import React from "react";

const RevertPayment = () => {
  return <div>RevertPayment</div>;
};

export default RevertPayment;
